/**
 * Map center coordinates for Canada.
 * Used to position maps consistently across all search pages.
 *
 * Coordinates are [latitude, longitude] for Leaflet compatibility.
 */

/** Center of Canada - consistent across all search pages */
export const CANADA_CENTER: [number, number] = [50, -89];
export const CANADA_ZOOM = 3.75;
